import { render, staticRenderFns } from "./favoritesPage.vue?vue&type=template&id=adbdba66&scoped=true"
import script from "./favoritesPage.vue?vue&type=script&lang=js"
export * from "./favoritesPage.vue?vue&type=script&lang=js"
import style0 from "./favoritesPage.vue?vue&type=style&index=0&id=adbdba66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adbdba66",
  null
  
)

export default component.exports